import React, { FunctionComponent } from 'react';
import { RecipePreview } from '../../../types/recipePreview';
import { urlFor } from '../../../utils/imageBuilder';
import InternalLink from '../../InternalLink';
import './styles.scss';

type RecipeListCardProps = {
  recipe: RecipePreview;
}

const RecipeListCard: FunctionComponent<RecipeListCardProps> = ({ recipe }) => {
  return (
    <InternalLink
      reference={recipe}
      className='recipe-list-card'
    >
      <div className='recipe-list-card-image'>
        <img
          src={urlFor(recipe.teaser?.image?.asset ? recipe.teaser.image : recipe.image).width(260).height(190).fit('clip').quality(90).url()}
          alt={recipe.image.alt}
        />
      </div>
      <div>
        <strong>{recipe.teaser?.title ? recipe.teaser.title : recipe.title}</strong>
      </div>
    </InternalLink>
  );
}

export default RecipeListCard;
